import Image from "next/image";
import type { PieceSymbol } from "chess.js";

export type ArtworkScene = "play" | "learn" | "puzzles" | "openings";

/**
 * Theme-specific editorial renders; playable boards retain their live 3D renderer. Both
 * themes are rendered and CSS shows the one matching <html data-theme>, which is set
 * before first paint, so light-theme readers never see the dark art swap in.
 */
export function ChessArtwork({ piece = "n", variant = 0, scene, eager = false, sizes }: { piece?: PieceSymbol; variant?: number; scene?: ArtworkScene; eager?: boolean; sizes?: string }) {
  const subject = scene ?? (piece === "n" ? "learn" : piece === "b" ? "puzzles" : piece === "r" ? "openings" : "play");
  const imageSizes = sizes ?? (subject === "openings" ? "(max-width:800px) 100vw, 650px" : "(max-width:800px) 100vw, 450px");
  return <div className={`chess-artwork artwork-${subject} art-${variant % 4}`} aria-hidden="true">
    {(["dark", "light"] as const).map((theme) => <Image key={theme} className={`art-theme-${theme}`} src={`/images/atelier/${subject}-${theme}.webp`} alt="" fill loading={eager ? "eager" : "lazy"} sizes={imageSizes} />)}
    {subject === "learn" && <svg className="art-move-path" viewBox="0 0 400 260" fill="none"><path d="M65 198H122V145" stroke="currentColor" strokeWidth="1.2"/><circle cx="65" cy="198" r="2.5" fill="currentColor"/><circle cx="122" cy="145" r="2.5" fill="currentColor"/></svg>}
  </div>;
}
